import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  LEAVE_REQUEST_GET_REQUEST,
  LEAVE_REQUEST_GET_SUCCESS,
  LEAVE_REQUEST_GET_FAILURE,
  LEAVE_REQUEST_GET_RESET,
  LEAVE_REQUEST_CREATE_REQUEST,
  LEAVE_REQUEST_CREATE_SUCCESS,
  LEAVE_REQUEST_CREATE_FAILURE,
  LEAVE_REQUEST_CREATE_RESET,
  LEAVE_REQUEST_APPROVE_REQUEST,
  LEAVE_REQUEST_APPROVE_SUCCESS,
  LEAVE_REQUEST_APPROVE_FAILURE,
  LEAVE_REQUEST_APPROVE_RESET,
  LEAVE_REQUEST_PREVIEW_REQUEST,
  LEAVE_REQUEST_PREVIEW_SUCCESS,
  LEAVE_REQUEST_PREVIEW_FAILURE,
  LEAVE_REQUEST_PREVIEW_RESET,
  LEAVE_REQUEST_CANCEL_REQUEST,
  LEAVE_REQUEST_CANCEL_SUCCESS,
  LEAVE_REQUEST_CANCEL_FAILURE,
  LEAVE_REQUEST_CANCEL_RESET,
} from './../../constants'

export function createLeaveRequest(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-requests?commit=true`,
      method: 'POST',
      types: [
        LEAVE_REQUEST_CREATE_REQUEST,
        LEAVE_REQUEST_CREATE_SUCCESS,
        LEAVE_REQUEST_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function previewLeaveRequest(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-requests?commit=false`,
      method: 'POST',
      types: [
        LEAVE_REQUEST_PREVIEW_REQUEST,
        LEAVE_REQUEST_PREVIEW_SUCCESS,
        LEAVE_REQUEST_PREVIEW_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getLeaveRequest(access_token, teamCalendar = false) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-requests?team-calendar=${teamCalendar}`,
      method: 'GET',
      types: [
        LEAVE_REQUEST_GET_REQUEST,
        LEAVE_REQUEST_GET_SUCCESS,
        LEAVE_REQUEST_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function approveLeaveRequest(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-requests/approve/${id}`,
      method: 'POST',
      types: [
        LEAVE_REQUEST_APPROVE_REQUEST,
        LEAVE_REQUEST_APPROVE_SUCCESS,
        LEAVE_REQUEST_APPROVE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function cancelLeaveRequest(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/leave-requests/cancel/${id}`,
      method: 'POST',
      types: [
        LEAVE_REQUEST_CANCEL_REQUEST,
        LEAVE_REQUEST_CANCEL_SUCCESS,
        LEAVE_REQUEST_CANCEL_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function resetGetLeaveRequest() {
  return {
    type: LEAVE_REQUEST_GET_RESET,
  }
}
export function resetCreateLeaveRequest() {
  return {
    type: LEAVE_REQUEST_CREATE_RESET,
  }
}
export function resetApproveLeaveRequest() {
  return {
    type: LEAVE_REQUEST_APPROVE_RESET,
  }
}
export function resetPreviewLeaveRequest() {
  return {
    type: LEAVE_REQUEST_PREVIEW_RESET,
  }
}
export function resetCancelLeaveRequest() {
  return {
    type: LEAVE_REQUEST_CANCEL_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/leave-request/leave-request-action.js